module.exports = [{
      plugin: require('/Users/danielpendergast/Sites/blog/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":960},
    },{
      plugin: require('/Users/danielpendergast/Sites/blog/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/danielpendergast/Sites/blog/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/Users/danielpendergast/Sites/blog/src/cms/cms.js"},
    },{
      plugin: require('/Users/danielpendergast/Sites/blog/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-138581270-1"],"pluginConfig":{"head":true}},
    },{
      plugin: require('/Users/danielpendergast/Sites/blog/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/danielpendergast/Sites/blog/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/danielpendergast/Sites/blog/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
